import backendVerifiedUser from "../../api/backendVerifiedUser";
import {
  CLOSE_LOADER,
  SET_ERROR,
  SET_LOADER,
  SET_SUCCESS,
} from "../Types/AuthTypes";
import {
  SET_SLOTS,
  UPDATE_SLOT,
  SET_SLOT_PRODUCTS,
  ASSIGN_PRODUCTS_TO_SLOT,
  REMOVE_PRODUCT_FROM_SLOT,
  SET_PRODUCTS_FOR_SLOTS,
} from "../Types/SlotTypes";

export const getSlots = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/get-slots");
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SLOTS, payLoad: response.data });
    } catch (err) {
      // Mock data for testing when backend is not available
      console.log("Using mock data for slots:", err.message);
      const mockSlots = [
        { id: 1, name: "Featured Products", products: [], position: 1, is_enabled: true },
        { id: 2, name: "Best Sellers", products: [], position: 2, is_enabled: true },
        { id: 3, name: "New Arrivals", products: [], position: 3, is_enabled: true },
        { id: 4, name: "Trending Now", products: [], position: 4, is_enabled: true },
        { id: 5, name: "Weekly Specials", products: [], position: 5, is_enabled: true },
        { id: 6, name: "Top Rated", products: [], position: 6, is_enabled: true },
        { id: 7, name: "Clearance Sale", products: [], position: 7, is_enabled: true },
        { id: 8, name: "Recommended", products: [], position: 8, is_enabled: true },
      ];
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SLOTS, payLoad: mockSlots });
    }
  };
};

export const updateSlot = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(`/update-slot/${id}`, data);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      dispatch({ type: UPDATE_SLOT, payLoad: { id, ...data } });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const assignProductsToSlot = (slotId, productIds) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(`/assign-products-to-slot/${slotId}`, { productIds });
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      dispatch({ type: ASSIGN_PRODUCTS_TO_SLOT, payLoad: { slotId, productIds } });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const removeProductFromSlot = (slotId, productId) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.delete(`/remove-product-from-slot/${slotId}/${productId}`);
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      dispatch({ type: REMOVE_PRODUCT_FROM_SLOT, payLoad: { slotId, productId } });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const getProductsForSlots = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/get-products-for-slots");
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_PRODUCTS_FOR_SLOTS, payLoad: response.data });
    } catch (err) {
      // Mock data for testing when backend is not available
      console.log("Using mock data for products:", err.message);
      const mockProducts = [
        {
          id: 1,
          title: "Sample Product 1",
          sku: "SP001",
          price: 100,
          discount: 10,
          discount_type: "percentage",
          image_path: "",
          all_images: [{ image: "https://dummyimage.com/200x200/cccccc/000000&text=Product+1" }],
          stock: 50,
          category: "Electronics"
        },
        {
          id: 2,
          title: "Sample Product 2",
          sku: "SP002",
          price: 200,
          discount: 0,
          discount_type: "fixed",
          image_path: "",
          all_images: [{ image: "https://dummyimage.com/200x200/cccccc/000000&text=Product+2" }],
          stock: 30,
          category: "Fashion"
        },
        {
          id: 3,
          title: "Sample Product 3",
          sku: "SP003",
          price: 150,
          discount: 15,
          discount_type: "fixed",
          image_path: "",
          all_images: [{ image: "https://dummyimage.com/200x200/cccccc/000000&text=Product+3" }],
          stock: 20,
          category: "Home & Garden"
        }
      ];
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_PRODUCTS_FOR_SLOTS, payLoad: mockProducts });
    }
  };
};

export const reorderSlots = (positions) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post("/reorder-slots", { positions });
      dispatch({ type: CLOSE_LOADER });
      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      // Refresh slots to get updated positions
      dispatch(getSlots());
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const getSlotProducts = (slotId, limit = 10) => {
  return async (dispatch) => {
    if (!slotId) return;

    try {
      const response = await backendVerifiedUser.get(`/get-products-by-slot/${slotId}?limit=${limit}`);
      dispatch({
        type: SET_SLOT_PRODUCTS,
        payLoad: { slotId, products: response.data }
      });
    } catch (err) {
      // Mock data for testing when backend is not available
      console.log("Using mock data for slot products:", err.message);
      const mockProducts = [
        {
          id: 1,
          title: "Sample Product 1",
          sku: "SP001",
          price: 100,
          discount: 10,
          discount_type: "percentage",
          image_path: "",
          all_images: [{ image: "https://dummyimage.com/200x200/cccccc/000000&text=Product+1" }],
          stock: 50,
          category: "Electronics"
        },
        {
          id: 2,
          title: "Sample Product 2",
          sku: "SP002",
          price: 200,
          discount: 0,
          discount_type: "fixed",
          image_path: "",
          all_images: [{ image: "https://dummyimage.com/200x200/cccccc/000000&text=Product+2" }],
          stock: 30,
          category: "Fashion"
        },
        {
          id: 3,
          title: "Sample Product 3",
          sku: "SP003",
          price: 150,
          discount: 15,
          discount_type: "fixed",
          image_path: "",
          all_images: [{ image: "https://dummyimage.com/200x200/cccccc/000000&text=Product+3" }],
          stock: 20,
          category: "Home & Garden"
        }
      ];
      dispatch({
        type: SET_SLOT_PRODUCTS,
        payLoad: { slotId, products: mockProducts.slice(0, limit) }
      });
    }
  };
};